export default __webpack_public_path__ + "static/media/backgroundImg.2b8e06f5.png";